import type { AccountStateReason, UserDto } from '@/types/generated/schemas';

type RowReason = NonNullable<UserDto['blocked_actions']>[string];
type SharedReason = Extract<AccountStateReason, 'ACCOUNT_OPERATION_IN_PROGRESS' | 'MAINTENANCE_FREEZE'>;
export type InvitationRevokeReason = RowReason | SharedReason;

const reasons: ReadonlySet<string> = new Set<InvitationRevokeReason>([
  'SETUP_IN_PROGRESS',
  'NEEDS_REPAIR',
  'REVOKE_UNFINISHED',
  'REVOKE_IN_PROGRESS',
  'READ_ONLY',
  'NOT_AUTHORIZED',
  'NOT_SUPPORTED',
  'ALREADY_ACCEPTED',
  'RESOLUTION_CONFLICT',
  'TENANT_NOT_READY',
  'ACCOUNT_OPERATION_IN_PROGRESS',
  'MAINTENANCE_FREEZE',
]);

export const getInvitationRevokeReason = (error: unknown): InvitationRevokeReason | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const value = error as { reason?: unknown; data?: { reason?: unknown } };
  const reason = value.reason ?? value.data?.reason;
  return typeof reason === 'string' && reasons.has(reason) ? (reason as InvitationRevokeReason) : undefined;
};

export const revokeReasonMessages: Record<InvitationRevokeReason, string | undefined> = {
  SETUP_IN_PROGRESS: 'Account setup is in progress. Please retry shortly.',
  NEEDS_REPAIR: 'This invitation needs support to resolve it.',
  REVOKE_UNFINISHED: 'The previous revoke did not finish. Use Retry revoke.',
  REVOKE_IN_PROGRESS: 'Another revoke for this email is running.',
  READ_ONLY: 'This roster is in read-only mode.',
  NOT_AUTHORIZED: 'This action is not available to you.',
  NOT_SUPPORTED: 'This action is not available for this invitation.',
  ALREADY_ACCEPTED: 'This invitation was accepted. The row has been refreshed.',
  RESOLUTION_CONFLICT: 'A different decision was already recorded. The row has been refreshed.',
  TENANT_NOT_READY: 'Account recovery is not ready for this organization.',
  ACCOUNT_OPERATION_IN_PROGRESS: undefined,
  MAINTENANCE_FREEZE: undefined,
};
